import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useDonationFormsStore } from '../store';
import FormBuilderFields from './FormBuilderFields.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'FormBuilderRenderer',
  props: {
	formBuilderConfig: {
		type: Object,
		required: true
	},
	step: {
		type: String,
		required: true
	},
	currencies: Object,
	symbols: Object,
	symbol: String,
	strings: Object,
	show_recurring: Boolean,
	causes_list: Object,
	donation_custom_dropdown: Object,
	gateways: Object,
	billingFormData: Object
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const store = useDonationFormsStore();
const lifeline_donation = globalThis.lifeline_donation;
const _ = globalThis._;

const step1Fields = computed(() => {
	if (!props.formBuilderConfig?.fields) return [];
	return props.formBuilderConfig.fields.filter((f: any) => f.step === 'step_1');
});

const step2Fields = computed(() => {
	if (!props.formBuilderConfig?.fields) return [];
	return props.formBuilderConfig.fields.filter((f: any) => f.step === 'step_2');
});

const step3Fields = computed(() => {
	if (!props.formBuilderConfig?.fields) return [];
	return props.formBuilderConfig.fields.filter((f: any) => f.step === 'step_3');
});

const getSymbol = () => {
	return props.symbols?.[store.currency] ?? props.symbol;
};

const convert = (amt: number) => {
	const { exchange_rates } = lifeline_donation;
	const syb = store.currency;
	if (_.get(exchange_rates, syb)) {
		return (_.get(exchange_rates, syb) * amt).toFixed(2);
	}
	return amt;
};

const getAmounts = (field: any) => {
	return field.amounts || [];
};

const setValue = (key: string, val: string | number) => {
	store[key] = val;
};

const setRecurring = (value: boolean) => {
	store.recurring = value;
};

const isNumber = (evt: KeyboardEvent) => {
	const charCode = evt.which || evt.keyCode;
	if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
		evt.preventDefault();
	}
};

const updateAmount = (event: Event) => {
	const target = event.target as HTMLInputElement;
	if (target.value) {
		store.amount = parseFloat(target.value);
	} else {
		store.amount = null;
	}
};

const __returned__ = { props, store, lifeline_donation, _, step1Fields, step2Fields, step3Fields, getSymbol, convert, getAmounts, setValue, setRecurring, isNumber, updateAmount, FormBuilderFields }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})